const organizationVariables = [
  'color',
  'bg',
  'borderColor',
  'hoverColor',
  'hoverBg',
  'hoverBorder',
  'focusShadow',
  'activeColor',
  'activeBg',
  'activeBorder',
  'activeShadow',
  'disabledColor',
  'disabledBg',
  'disabledBorder'
]

const StyleConfig = class {
  style = {}
  image = ''
  hoverImage = ''

  /**
   * @param {object} context
   */
  constructor (context) {
    if (context === undefined || Object.keys(context).length === 0) {
      throw new Error('StyleConfig must be initialized with a context')
    }

    if (Object.keys(context.organizationSettings).length === 0) {
      throw new Error('StyleConfig must be initialized with a context containing organizationSettings')
    }

    this.generateConfig(context)
  }

  /**
   * @param {object} context
   */
  generateConfig (context) {
    this.style = this.generateStyle(context)
    this.image = context.organizationSettings.bankIdImage
    this.hoverImage = context.organizationSettings.bankIdImageHover
  }

  /**
   * @param {object} context
   * @returns {object[]} style configurations for SCSS
   */
  generateStyle (context) {
    const objectList = []

    organizationVariables.forEach(setting => {
      if (context.organizationSettings[setting] !== undefined) {
        const key = '--bankid-' + setting.replace(/([A-Z])/g, '-$1').toLowerCase()
        objectList.push({ [key]: context.organizationSettings[setting] })
      }
    })

    return (objectList.length > 0) ? Object.assign(...objectList) : {}
  }
}

export default StyleConfig
